<!--
 * @Description  : 知识库管理 - 类型管理 - 新增/编辑/查看文库类型
 * @Author       : zcc
 * @Date         : 2025-04-23 15:25:15
 * @LastEditors: zcc
 * @LastEditTime: 2025-05-16 14:45:07
 * @FilePath: \ngs_platform_manage_admin\src\views\operation-management\library\library-type-management\components\addTypeDialog.vue
-->
<template>
  <div>
    <el-dialog
      :title="dialogObj.title"
      v-if="dialogObj.visible"
      :visible.sync="dialogObj.visible"
      :width="dialogObj.width"
      :close-on-click-modal="false"
      max-height="630px"
      @close="closeDialog"
    >
      <template>
        <Panel title="#1 创建人信息" :expand="false">
          <el-form
            class="tableForm"
            ref="userForm"
            :model="userForm"
            label-width="150px"
          >
            <el-form-item label="发起人" prop="createUser" required>
              <el-input v-model="userForm.createUser" disabled></el-input>
            </el-form-item>
          </el-form>
        </Panel>
        <Panel title="#2 文库类型信息" :expand="true">
          <el-form
            class="tableForm"
            ref="libraryForm"
            :model="libraryForm"
            label-width="150px"
            :rules="rules"
          >
            <el-form-item label="类型名称" prop="sname" required>
              <el-input
                :disabled="dialogObj.type == 'view'"
                placeholder="请输入"
                :maxlength="50"
                v-model="libraryForm.sname"
              ></el-input>
            </el-form-item>
            <el-form-item label="节点简称">
              <el-input
                :disabled="dialogObj.type == 'view'"
                placeholder="请输入"
                :maxlength="50"
                v-model="libraryForm.shortName"
              ></el-input>
            </el-form-item>
            <el-form-item label="节点类型">
              <div class="pdl20">
                {{ `${toChinese(libraryForm.level)}级类型` }}
              </div>
            </el-form-item>
            <el-form-item label="节点图标">
              <public-upload
                :isDisabled="dialogObj.type == 'view'"
                ref="enclosure"
                :aid="iconAid"
                width="700px"
                listType="text"
                tableName="lib_doc_type"
                assortment="typeManagement"
                :maxNum="1"
                :acceptType="accept"
                :fileSize="50"
              ></public-upload>
            </el-form-item>
            <!-- <el-form-item label="责任部门" v-if="libraryForm.level == 1">
              <el-input
                :disabled="dialogObj.type == 'view'"
                v-model="libraryForm.dutyDeptNames"
                :maxlength="50"
                placeholder="请输入"
              ></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="责任人" v-if="libraryForm.level == 1">
              <el-input
                :disabled="dialogObj.type == 'view'"
                v-model="libraryForm.dutyUserNames"
                :maxlength="50"
                placeholder="请输入"
              ></el-input>
            </el-form-item> -->
            <el-form-item label="说明">
              <el-input
                :disabled="dialogObj.type == 'view'"
                placeholder="请输入"
                v-model="libraryForm.remark"
                :maxlength="50"
              ></el-input>
            </el-form-item>
          </el-form>
        </Panel>
        <Panel
          title="#3 检索页配置"
          :expand="true"
          v-if="libraryForm.level == '1'"
        >
          <el-form
            class="tableForm"
            ref="searchForm"
            :model="searchForm"
            label-width="150px"
            :rules="ruleForm"
          >
            <el-form-item label="标题" prop="title" required>
              <el-input
                :disabled="dialogObj.type == 'view'"
                placeholder="请输入"
                :maxlength="50"
                v-model="searchForm.title"
              ></el-input>
            </el-form-item>
            <el-form-item label="别名" prop="alias" required>
              <el-input
                :disabled="dialogObj.type == 'view'"
                placeholder="请输入英文字母"
                :maxlength="50"
                v-model="searchForm.alias"
                @blur="englishChange(searchForm.alias, 'alias')"
              ></el-input>
            </el-form-item>
            <el-form-item label="检索页地址" prop="subdomain">
              <el-input
                :disabled="dialogObj.type == 'view'"
                placeholder="请输入"
                v-model="searchForm.subdomain"
                clearable
                :maxlength="100"
              ></el-input>
            </el-form-item>
            <el-form-item label="检索页Logo">
              <public-upload
                :isDisabled="dialogObj.type == 'view'"
                ref="enclosure"
                :aid="logoAid"
                width="700px"
                listType="text"
                tableName="lib_doc_type"
                assortment="lib_doc_type_logo"
                :maxNum="1"
                :acceptType="accept"
                :fileSize="50"
              ></public-upload>
            </el-form-item>
            <el-form-item label="二级分类展示">
              <template v-if="dialogObj.type == 'view'">
                <div class="pdl20">
                  {{
                    searchForm.showType && searchForm.showType == 0
                      ? "平铺"
                      : "下拉"
                  }}
                </div>
              </template>
              <template v-else>
                <el-radio-group v-model="searchForm.showType">
                  <el-radio label="0">平铺</el-radio>
                  <el-radio label="1">下拉</el-radio>
                </el-radio-group>
              </template>
            </el-form-item>
            <el-form-item label="默认展示条数" prop="showNum" required>
              <el-input
                :disabled="dialogObj.type == 'view'"
                placeholder="请输入数字"
                v-model="searchForm.showNum"
                :maxlength="2"
                clearable
                @blur="numberChange(searchForm.showNum, 'showNum')"
              >
                <template slot="append">条</template>
              </el-input>
            </el-form-item>
            <el-form-item label="检索详情页设置">
              <el-checkbox-group v-model="searchForm.tabArr">
                <el-checkbox
                  v-for="(item, index) of settingArr"
                  :key="'setting' + index"
                  :disabled="item.disabled || dialogObj.type == 'view'"
                  :label="item.value"
                >
                  {{ item.sname }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-form>
        </Panel>
        <div
          slot="footer"
          class="dialog-footer text-center"
          v-if="dialogObj.type != 'view'"
        >
          <el-button size="small" @click="closeDialog">取 消</el-button>
          <el-button
            type="primary"
            size="small"
            :loading="btnLoading"
            @click="doSave"
          >
            提交
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import * as typeApi from "api/modules/library/library-type-management/index.js";
import Panel from "components/panel/Panel";
import { returnChinese } from "@/utils/tools";
import { Snowflake } from "node-snowflake";
import NewUpload from "./new-upload/newUpload.vue";
const jssz_dict = {
  zwxx: "1001033001", //正文信息
  zwwd: "1001033002", //正文文档
  xgfj: "1001033003", //相关附件
  wdxx: "1001033004" //文档信息
}; //检索详情页设置
export default {
  components: { Panel, NewUpload },
  props: {
    dialogObj: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      rangeList: [], // 选中人员数据
      selectedArr: [],
      btnLoading: false,
      userForm: {
        createUser: "", //发起人
        createUserid: "", //发起人id
        createDate: "" //发起时间
      }, // 当前登录人信息
      libraryForm: {
        id: "", //
        sname: "", //类型名称
        shortName: "", // 节点简称
        rootId: "", //所属根节点id
        level: "", //层级(节点类型)
        pid: "", //父级节点id
        remark: "", //备注
        title: "", //标题
        alias: "", //别名
        subdomain: null, //检索页地址
        showType: "1", //分类展示 0：平铺；1：下拉
        showNum: 6 //默认展示条数
      }, // 文库类型信息
      searchForm: {
        title: "", //标题
        alias: "", //别名
        subdomain: null, //检索页地址
        showType: "1", //分类展示 0：平铺；1：下拉
        showNum: 6, //默认展示条数
        // showTabs:'',//检索详情页设置
        tabArr: [jssz_dict.zwxx, jssz_dict.zwwd, jssz_dict.xgfj, jssz_dict.wdxx] //检索详情页设置数组
      }, // 检索页表单信息
      // 校验
      rules: {
        sname: [
          {
            required: true,
            message: "类型名称不能为空",
            trigger: ["blur", "change"]
          }
        ]
      },
      ruleForm: {
        title: [
          {
            required: true,
            message: "标题不能为空",
            trigger: ["blur", "change"]
          }
        ],
        alias: [
          {
            required: true,
            message: "别名不能为空",
            trigger: ["blur", "change"]
          },
          {
            required: true,
            message: "别名不能为空",
            trigger: ["blur", "change"]
          }
        ],
        showNum: [
          {
            required: true,
            message: "默认展示条数不能为空",
            trigger: ["blur", "change"]
          }
        ],
        subdomain: [
          {
            pattern: /^[^\u4e00-\u9fa5]+$/,
            message: "不能输入中文",
            trigger: ["blur", "change"]
          }
        ]
      },
      accept: ["png", "jpg", "svg"], //接受上传文件类型
      iconAid: "", //节点图标aid
      logoAid: "" //logo aid
    };
  },
  mounted() {
    if (this.dialogObj.type == "add") {
      // 添加1级节点时赋的默认值
      this.libraryForm.level = "1";
      this.libraryForm.rootId = this.dialogObj.id;
      this.libraryForm.pid = "0";
      this.libraryForm.id = this.dialogObj.id;
      this.iconAid = this.dialogObj.id; // 给节点图标aid赋值
      this.logoAid = this.dialogObj.id; // logo aid
    } else if (this.dialogObj.type == "nodeAdd") {
      // 点击添加子节点时赋的默认值
      this.getNodeAdd(this.dialogObj.row);
    } else {
      this.viewEdit(this.dialogObj.row);
    }
    this.initDialog(this.dialogObj.type);
  },
  methods: {
    //点击添加子节点时赋的默认值
    getNodeAdd(row) {
      let busId = Snowflake.nextId();
      this.libraryForm.level = row.level * 1 + 1;
      this.libraryForm.rootId = row.rootId;
      this.libraryForm.pid = row.id;
      this.libraryForm.id = busId;
      this.iconAid = busId; // 给节点图标aid赋值
      this.logoAid = busId; // logo aid
      this.initDialog("nodeAdd");
    },
    //查看与编辑
    viewEdit(row) {
      typeApi.libDocTypeInfo({ id: row.id }).then(res => {
        if (res.code == 0) {
          this.userForm = { ...res.data.applyerInfo };
          this.libraryForm = {
            ...this.libraryForm,
            ...res.data.libDocType
          };
          Object.keys(res.data.libDocType).map(key => {
            this.searchForm[key] = res.data.libDocType[key];
          });
          this.searchForm.tabArr = res.data.libDocType.showTabs?.split(",");
          this.iconAid = this.libraryForm.id;
          this.logoAid = this.libraryForm.id;
        }
      });
    },
    //获取数据
    initDialog(type) {
      // 新增模式下获取发起人信息
      if (type != "view" || type != "edit") {
        this.getDataList();
      }
    },
    /*校验*/
    numberChange(value, sname) {
      this.searchForm[sname] = value;
      // 验证是否是数字，并且在5-10之间
      const regExp = /^\d+?$/;
      if (value && !regExp.test(value)) {
        this.searchForm.showNum = ""; //清空
        return this.$message.warning({ message: "只能为数字" });
      }
      const values = parseInt(value, 10);
      if (isNaN(values) || values < 5 || values > 10) {
        this.searchForm.showNum = ""; //清空
        return this.$message.warning({
          message: "请输入5到10之间的数字！"
        });
      }
    },
    //别名校验
    englishChange(value, sname) {
      this.searchForm[sname] = value;
      // 验证是否是英文字母，并且不超过50个字符
      const regex = /^[a-zA-Z]*$/; // 正则表达式，只匹配英文字母
      if (!regex.test(value)) {
        this.searchForm[sname] = ""; // 清空输入框
        return this.$message.warning({ message: "请输入英文字母。" });
      }
    },
    //转换成中文
    toChinese(data) {
      let str = returnChinese(data);
      return str;
    },
    //保存
    doSave() {
      this.$refs.libraryForm.validate(valid => {
        if (valid) {
          if (this.libraryForm.level == 1) {
            this.$refs.searchForm.validate(valid => {
              if (valid) {
                // 调接口提交
                this.libraryForm.title = this.searchForm.title;
                this.libraryForm.alias = this.searchForm.alias;
                this.libraryForm.subdomain = this.searchForm.subdomain;
                this.libraryForm.showType = this.searchForm.showType;
                this.libraryForm.showNum = this.searchForm.showNum;
                this.libraryForm.showTabs = this.searchForm.tabArr.join();
                let params = {
                  applyerInfo: this.userForm,
                  libDocType: this.libraryForm
                };
                this.submit(params);
              } else {
                this.$message.error({
                  message: "请完善检索页信息"
                });
              }
            });
          } else {
            // 调接口提交
            let param = {
              applyerInfo: this.userForm,
              libDocType: this.libraryForm
            };
            this.submit(param);
          }
        } else {
          this.$message.error({ message: "请完善信息" });
        }
      });
    },
    //提交
    submit(row) {
      typeApi
        .saveLibDocType(row)
        .then(res => {
          if (res.code == 0) {
            this.$message.success({
              message: "提交成功！"
            });
            if (this.dialogObj.type == "add") {
              setTimeout(() => {
                this.$emit("success", "add");
                this.closeDialog(); // 关闭弹窗
              }, 500);
            } else {
              setTimeout(() => {
                this.$emit("success", row.libDocType);
                this.closeDialog(); // 关闭弹窗
              }, 500);
            }
          }
        })
        .catch(e => {});
    },
    //关闭弹窗
    closeDialog() {
      // 重置所有数据
      Object.assign(this.$data, this.$options.data());
      this.dialogObj.visible = false;
      setTimeout(() => {
        this.btnLoading = false;
      }, 1000);
    },
    //基本信息
    getDataList() {
      Object.keys(this.userForm).forEach(key => {
        switch (key) {
          case "createUser":
            this.$set(this.userForm, key, this.userInfo.sname);
            break;
          case "createUserid":
            this.$set(this.userForm, key, this.userInfo.id);
            break;
          case "createDate":
            this.$set(this.userForm, key, this.userInfo.createDate);
            break;
        }
      });
    }
  },
  computed: {
    ...mapState("user", {
      userInfo: state => state.userInfo
    }),
    ...mapState("dict", {
      projectDict: state => state.projectDict
    }),
    settingArr() {
      let arr = this.projectDict.zskjsyxqypz.map(item => {
        if (item.value == jssz_dict.xgfj) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
        return item;
      });
      return arr;
    }
  },
  created() {},
  watch: {}
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__body {
  padding: 10px 30px;
  max-height: 68vh;
  overflow-y: auto;
  font-size: 14px;
}
</style>
